var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.467,23.316,12,17.828,4.533,23.316,7.4,14.453-.063,9H9.151L12,.122,14.849,9h9.213L16.6,14.453Z"}));
}

Star.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 24 24","fill":"#FFCE31"};

module.exports = Star;

Star.default = Star;
